import script from "./AppLayoutDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLayoutDefault.vue?vue&type=script&setup=true&lang=js"

import "./AppLayoutDefault.vue?vue&type=style&index=0&id=e73d8f0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e73d8f0a"]])

export default __exports__